import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CheckboxesContainer, CheckboxAndLabel, CheckboxClickableArea, CheckboxLabelAndLink, CheckboxLabel, CheckboxOrange } from './styled-components/Checkboxes'
import GDPRLinkOrangeSmall from './styled-components/GDPRLinkOrangeSmall'

const GDPRCheckboxes = (props) => {
  return (
    <CheckboxesContainer data-gdpr-checkboxes>

      <CheckboxAndLabel>
        <CheckboxClickableArea onClick={props.handleGDPRPrivacyPolicyCheckboxChange}>
          <CheckboxOrange checked={props.privacyPolicyChecked}>
            {props.privacyPolicyChecked ? <FontAwesomeIcon icon="check" color="white" /> : null}
          </CheckboxOrange>
        </CheckboxClickableArea>
        <CheckboxLabelAndLink>
          <CheckboxLabel>I agree to the</CheckboxLabel>
          <CheckboxLabel>
            <GDPRLinkOrangeSmall href="https://www.anovaculinary.com/privacy/">Privacy Policy</GDPRLinkOrangeSmall>
          </CheckboxLabel>
        </CheckboxLabelAndLink>
      </CheckboxAndLabel>

      <CheckboxAndLabel>
        <CheckboxClickableArea onClick={props.handleGDPRTermsOfServiceCheckboxChange}>
          <CheckboxOrange checked={props.termsOfServiceChecked}>
            {props.termsOfServiceChecked ? <FontAwesomeIcon icon="check" color="white" /> : null}
          </CheckboxOrange>
        </CheckboxClickableArea>
        <CheckboxLabelAndLink>
          <CheckboxLabel>I agree to the</CheckboxLabel>
          <CheckboxLabel>
            <GDPRLinkOrangeSmall href="https://www.anovaculinary.com/terms/">Terms of Service</GDPRLinkOrangeSmall>
          </CheckboxLabel>
        </CheckboxLabelAndLink>
      </CheckboxAndLabel>

    </CheckboxesContainer>
  )
}

export default GDPRCheckboxes
